import {
  Errors, ErrorsObjectArray, useErrorNotificationApi,
} from '@equifinance/shared';
import { Summary } from '../contexts/account/useSummary';
import { ProductLoanDetails } from '../contexts/products/Products';

const apiPath = `${process.env.REACT_APP_ORIGINATION_API_PATH}/`;

const apiUrl = (path: string) => `${apiPath}${path}`;

export enum DipTypes {
  PASS = 'Pass',
  FAIL = 'Fail',
}

export enum MinimumValuationTypeRequired {
  Avm = 'AVM',
  DriveBy = 'Drive-by',
  Full = 'Full valuation',
}

export type ProductType = {
    id: string,
    productId: string,
    isSelected: boolean,
    productType: string,
    initialMonthlyPayment: number,
    initialRate: number,
    reversionaryMonthlyPayment: number,
    reversionaryRate: number,
    aprc: number,
    ercProfile: string,
    overpaymentDetails: string,
    overpaymentTooltip: string,
    lenderFee: number,
    totalAmountRepayable: number,
    consentRequired: boolean,
    consentRequiredTooltip: string,
    minimumValuationTypeRequired: keyof typeof MinimumValuationTypeRequired,
    brokerCommission: number,
    brokerFee: number,
    errors: ErrorsObjectArray,
    warnings: ErrorsObjectArray,
    canDownloadESIS: boolean,
}

export type ProductsType = {
    id: string,
    products: ProductType[],
    productsResultDigest: string,
    isProductSelectionOverriden: boolean,
    errors: Errors,
    warnings: Errors,
}

export type HistoricDataItem = {
  id: string;
  productCode: string;
}

export type HistoricData = {
  productReferences: HistoricDataItem[];
}

export type CaseApiType = {
  getProductsSummary: (applicationId: string) => Promise<Summary>,
  getProducts: (applicationId: string) => Promise<ProductsType>,
  getProductHistoric: () => Promise<HistoricData>,
  setSelectedProduct: (applicationId: string, productId: string) => Promise<ProductsType>,
  getProductLoanDetails: (applicationId: string) => Promise<ProductLoanDetails>,
  setProductLoanDetails: (productLoanDetails: ProductLoanDetails) => Promise<ProductLoanDetails>,
}

const useProductsApi = (): CaseApiType => {
  const {
    put, post, get,
  } = useErrorNotificationApi(apiUrl);

  return {
    getProductsSummary: (applicationId: string) => get(`products/${applicationId}/summary`),
    getProducts: (applicationId: string) => get(`products/${applicationId}`),
    getProductHistoric: () => get('products/historic'),
    setSelectedProduct: (applicationId: string, productId: string) => put('products/set-product', { applicationId, productId }),
    getProductLoanDetails: (applicationId: string) => get(`products/${applicationId}/loan-and-property-details`),
    setProductLoanDetails: (productLoanDetails: ProductLoanDetails) => post('products/loan-and-property-details', productLoanDetails),
  };
};

export default useProductsApi;
